import { REQUEST_HANDLING_STRATEGIES } from './request-handling-strategy'

const requestHandlingDescriptor = Object.freeze({
    type: 'request-handling',
    version: 1,
    defaultTitleKey: 'Page(ReceivedRequest):Component(RequestHandling):title',
    fallbackTitle: 'How would you like to handle this request?',
    defaultNavigationTitleKey: 'Page(ReceivedRequest):Component(RequestHandling):navigation-title',
    fallbackNavigationTitle: 'Request handling',
    defaultDescriptionKey: 'Page(ReceivedRequest):Component(RequestHandling):description',
    fallbackDescription: 'Choose how you want to provide the requested information.',
    capabilities: {
        repeatable: false,
        supportedModes: ['single', 'bulk'],
        supportsReadOnly: false,
        contributesToReply: true,
    },
    dataScopes: {
        reads: [
            'request.details',
            'request.workflow-state',
            'request.forwarded-requests',
            'product.card',
            'product.hierarchy',
        ],
        writes: [
            'request.details',
            'request.workflow-state',
            'request.forwarded-requests',
            'product.card',
            'product.hierarchy',
        ],
    },
    effects: {
        publishes: [
            'request.details.changed',
            'request.workflow-state.changed',
            'product.card.changed',
            'product.hierarchy.changed',
            'request.forwarded.changed',
        ],
        observes: [],
    },
    settingsSchema: {
        type: 'object',
        additionalProperties: false,
        properties: {
            showOptionDescriptions: { type: 'boolean', default: true },
            showProductSupplierDetails: { type: 'boolean', default: true },
            showProductStructure: { type: 'boolean', default: false },
            showForwardedRequests: { type: 'boolean', default: true },
            bulkAllowedStrategies: {
                type: 'array',
                default: [...REQUEST_HANDLING_STRATEGIES],
                items: {
                    type: 'string',
                    enum: [...REQUEST_HANDLING_STRATEGIES],
                },
            },
            productStructure: {
                type: 'object',
                additionalProperties: false,
                default: {
                    mode: 'top-down',
                    showModeSelector: false,
                    requireAtLeastOneComponent: true,
                },
                properties: {
                    mode: {
                        type: 'string',
                        enum: ['top-down', 'bottom-up'],
                        default: 'top-down',
                    },
                    showModeSelector: { type: 'boolean', default: false },
                    requireAtLeastOneComponent: { type: 'boolean', default: true },
                },
            },
        },
    },
    settingsUi: {
        showOptionDescriptions: { control: 'switch' },
        showProductSupplierDetails: { control: 'switch' },
        showProductStructure: { control: 'switch' },
        showForwardedRequests: { control: 'switch' },
    },
})

export { requestHandlingDescriptor }
export default requestHandlingDescriptor
